export const RINGOVER_REAL_ESTATE_GROUP_IDS = [
  "62bc9c66f46e5f1c5420cd14", // Costa
  "5e9a2df024535649bdc51f54" // Prueba (default dev)
];
